import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ProjectCards from "./ProjectCards";
import tileDemo from "../../Assets/tileDemo.webm";
import ecommerceDemo from "../../Assets/ecommerceDemo.webm";
import carRental from "../../Assets/carrental.jpg"
import securityAPI from "../../Assets/security.jpg"
import workoutAPI from "../../Assets/workout.jpg"
import ansible from "../../Assets/ansible.jpg"
import terraform_kube from "../../Assets/terraform_kube.jpg"

function Project() {
  const projects = [
    {
      videoPath: tileDemo,
      title: "Tile Grid",
      description:
        "A custom mapping platform that integrates a secure backend API with a dynamic map UI. Users can upload GeoTIFF tiles generated from satellite or aerial imagery, which are automatically processed, stored securely, and displayed on the map in real time. The system intelligently overwrites tiles with the same name to ensure seamless updates, making it ideal for continuous data ingestion. The frontend provides a dark-themed map for clarity, with intuitive controls to pan, zoom, and auto-focus on the location of any selected tile. This solution is designed to make managing and visualizing geospatial data simple, interactive, and efficient.",
      tags: ["Web", "Automation", "Mapping"],
    },
    {
      imgPath: securityAPI,
      title: "Security API",
      description:
        "A robust API designed to manage user authentication and authorization for web applications. It features secure user registration, login, password management, and role-based access control. The API employs industry-standard security practices, including JWT tokens for session management and bcrypt for password hashing, ensuring that user data is protected against common vulnerabilities. Ideal for developers looking to integrate a reliable security layer into their applications with ease.",
      tags: ["API", "Security"],
    },
    { 
      imgPath: terraform_kube,
      title: "Terraform Kubernetes Module",
      description:
        "A comprehensive Terraform module that simplifies the deployment and management of Kubernetes clusters across various cloud providers. This module automates the provisioning of necessary infrastructure components, including networking, compute resources, and storage, while ensuring best practices for security and scalability are followed. It supports customization options for cluster size, node configurations, and add-ons, making it an ideal solution for developers and DevOps teams looking to streamline their Kubernetes deployments with Infrastructure as Code.",
      tags: ["Terraform", "Kubernetes", "Cloud", "DevOps", "Automation"]

    },
    {
      imgPath: workoutAPI,
      title: "AI Workout API",
      description:
        "An AI-powered workout routine generator that creates personalized exercise plans based on user-defined parameters such as fitness level, available equipment, target muscle groups, and workout duration. The API leverages advanced machine learning algorithms to analyze user inputs and generate optimized routines that adapt to individual goals and preferences. Whether you're a beginner looking for a simple routine or an advanced athlete seeking a challenging workout, this API provides tailored plans to help users achieve their fitness objectives effectively.",
      tags: ["API", "AI", "Fitness"]
    },
    {
      videoPath: ecommerceDemo,
      title: "E-Commerce Demo Platform",
      description:
        "A modern e-commerce platform that offers a seamless shopping experience with a focus on user-friendly design and efficient functionality. The platform features a clean, light-themed interface that highlights products effectively, making it easy for users to browse, search, and filter items. Key functionalities include a secure shopping cart, streamlined checkout process, and integration with popular payment gateways. The backend is built to handle inventory management, order processing, and customer data securely, ensuring a reliable and enjoyable shopping experience for users.",
      tags: ["Web", "E-Commerce"],
    },
    {
      imgPath: ansible,
      title: "Ansible Automation Role - CMMC RHEL",
      description:
        "An Ansible role designed to automate the configuration of Red Hat Enterprise Linux (RHEL) systems in compliance with Cybersecurity Maturity Model Certification (CMMC) requirements. This role streamlines the implementation of security controls, ensuring that RHEL environments meet stringent CMMC standards efficiently and consistently. Ideal for organizations seeking to enhance their cybersecurity posture while simplifying the management of compliance tasks.",
      tags: ["Ansible", "Automation", "Security"]
    },
    {
      imgPath: carRental,
      title: "AutoLink",
      description:
        "A sleek, modern platform for browsing and booking luxury cars. Users can explore a curated collection of vehicles, filter by category or location, and easily book their preferred ride. The design emphasizes clean visuals and an intuitive, enjoyable user experience.",
      tags: ["Web", "Automotive"],
    },
    // Add more projects here...
  ];

  const allTags = ["All", ...new Set(projects.flatMap(p => p.tags))];
  const [selectedTag, setSelectedTag] = useState("All");
  const [visibleCount, setVisibleCount] = useState(6);

  const filteredProjects =
    selectedTag === "All"
      ? projects
      : projects.filter(p => p.tags.includes(selectedTag));

  const showMore = () => setVisibleCount(prev => prev + 6);

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          Showcasing <strong className="red">Our Work</strong>
        </h1>
        <p style={{ color: "white" }}>
          Explore a selection of our in-house demo projects. Each one highlights
          our skills, creativity, and dedication to building reliable solutions.
        </p>
        <p style={{ color: "white", fontSize: "0.9rem" }}>
          <em>
            Note: The projects displayed below use sample/demo data only and do
            not contain or expose any real client information.
          </em>
        </p>

        {/* Filter Tags */}
        <div style={{ marginBottom: "20px" }}>
          {allTags.map(tag => (
            <Button
              key={tag}
              variant={selectedTag === tag ? "danger" : "outline-light"}
              size="sm"
              onClick={() => setSelectedTag(tag)}
              style={{ marginRight: "8px", marginBottom: "8px" }}
            >
              {tag}
            </Button>
          ))}
        </div>

        {/* Project Cards */}
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {filteredProjects.slice(0, visibleCount).map(project => (
            <Col md={4} className="project-card" key={project.title}>
              <ProjectCards
                imgPath={project.imgPath} 
                videoPath={project.videoPath}
                title={project.title}
                description={project.description}
                tags={project.tags}
              />
            </Col>
          ))}
        </Row>

        {/* Show More Button */}
        {visibleCount < filteredProjects.length && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Button variant="danger" onClick={showMore}>
              Show More
            </Button>
          </div>
        )}
      </Container>
    </Container>
  );
}

export default Project;
